var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
/**
 * A js file containing exports that relate to
 * the functionality and styles of the TextInputBase component.
 * The component uses styled-components to render.
 * @object
 * @param {object} props - React props.
 * @returns {JSX.Element} - Rendered component (define any specifics if applicable)
 */

var textInputColors = {
  grayLight: '#cfd8dc',
  mutedBlue: '#8793ab',
  textColor: '#777'
};
var TextInputBase = styled.input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-shadow: none;\n  height: 38px;\n  cursor: auto;\n  border: 1px solid ", ";\n  padding: 19px;\n  outline: none;\n  border-radius: 4px;\n  color: ", ";\n  margin: 0;\n  width: 100%;\n  font-family: Montserrat, Arial;\n  font-size: 17px;\n  display: flex;\n  background: ", ";\n  box-sizing: border-box;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"])), textInputColors.grayLight, textInputColors.textColor, function (props) {
  return props.bgColor;
}, textInputColors.mutedBlue, textInputColors.mutedBlue);
export default TextInputBase;